import Box from "@mui/material/Box";

import { FS } from "@plannel/utils/font-util";

/**
 * 안건 상태 알약. 상태 색의 <b>단일 소스</b>다.
 *
 * 목록 카드 · 상세 헤더 · 표 뷰가 전부 이걸 쓴다. 색을 각 화면에서 인라인으로 정하면
 * 상태가 하나 늘 때 세 군데가 어긋난다.
 */
const STATUS_STYLE = {
  DRAFT: { color: "#4C6066", bgcolor: "#ECEFEF", labelKey: "meetingAgendaStatusDraft" },
  PUBLISHED: { color: "#02657A", bgcolor: "#DFEFF3", labelKey: "meetingAgendaStatusPublished" },
  IN_REVIEW: { color: "#7A5209", bgcolor: "#FBF0DC", labelKey: "meetingAgendaStatusInReview" },
  CLOSED: { color: "#1C6045", bgcolor: "#E3F1E9", labelKey: "meetingAgendaStatusClosed" }
};

export const AGENDA_STATUSES = Object.keys(STATUS_STYLE);

/**
 * 발행된 뒤에 오갈 수 있는 상태.
 *
 * <p>DRAFT 가 빠져 있는 것은 의도다 — 한 번 공유한 안건을 다시 "나만 보임" 으로 되돌리면
 * 이미 읽은 사람에게서 사라진다. 그건 삭제에 가깝지 상태 변경이 아니다.
 */
export const AGENDA_STATUSES_AFTER_PUBLISH = AGENDA_STATUSES.filter((code) => code !== "DRAFT");

export const getStatusLabelKey = (statusCd) =>
  STATUS_STYLE[statusCd]?.labelKey ?? "meetingAgendaStatusDraft";

const AgendaStatusChip = ({ statusCd, t }) => {
  const style = STATUS_STYLE[statusCd] ?? STATUS_STYLE.DRAFT;
  return (
    <Box
      component="span"
      sx={{
        fontSize: FS.CAPTION,
        fontWeight: 700,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        color: style.color,
        bgcolor: style.bgcolor,
        borderRadius: 1,
        px: 1,
        py: 0.375,
        whiteSpace: "nowrap"
      }}
    >
      {t(style.labelKey)}
    </Box>
  );
};

export default AgendaStatusChip;
